/*
 * Note: _tokens are provided for future reference
 * Rename to tokens if used
 */
export const getThemeSpinner = (_tokens) => ({
    // TODO: Just make a new component instead of using the old one ?
    MuiCircularProgress: {
        defaultProps: {
            variant: 'indeterminate',
        },
        styleOverrides: {
            root: {
                animationDuration: '800ms',
                background: `conic-gradient(rgb(255,255,255,0), currentcolor)`,
                borderRadius: '50%',
                '--border-width': '2px',
                '--mask': `radial-gradient(
        farthest-side, 
        transparent calc(100% - var(--border-width) - 0.5px), 
        #000 calc(100% - var(--border-width) + 0.5px)
      )`,
                WebkitMask: 'var(--mask)',
                mask: 'var(--mask)',
            },
            // Just dump the svg
            circle: {
                display: 'none',
                animation: 'unset',
                WebkitAnimation: 'unset',
            },
        },
    },
});
